// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import { theme } from "./theme-APP_CLIENT";

export default theme;
